import React from 'react';
import {Backdrop, Card, Fade, Modal} from "@mui/material";
import Player from "../Player/Player";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import './styles.css'
import DOMPurify from "dompurify";
import {mediaUrl} from "../../config";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {xs: "95%", md: 800},
    backgroundColor: 'background.paper',
    p: 2,

}

const ModalComponent = ({open, onClose, url, obj}) => {

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Card sx={style} variant="outlined">
                    <div style={{display:"flex", justifyContent:"right", marginBottom:"-10px", marginTop:"-5px"}}>
                        <IconButton onClick={onClose}><CloseIcon sx={{color:"#00ADEF"}}/></IconButton>
                    </div>

                    {obj && (
                        <div>
                            <h3 className="modal-title">{obj.t}</h3>
                        </div>
                    )}

                    {url ? (
                        <Player url={url}/>
                    ):(
                        <div className="image-wrapper-modal"><img src={mediaUrl+obj.img} alt=""/></div>
                    )}

                    {obj && (
                        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(obj.cp)}}>
                        </div>
                    )}



                </Card>
            </Fade>
        </Modal>
    );
};

export default ModalComponent;